import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import {
  checkUnstableVersionUsage,
  recentlyWarned,
  unstableVersionUsageWarned
} from '../../reducers/dibsOpener';

const UnstableUsageDetector = ({
  fetch,
  fetched,
  fetching,
  detected,
  recordLastWarn,
  installer,
  proceed,
  cancel,
  onDownload,
  organizationId
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const handleClose = confirm => {
    if (confirm) {
      recordLastWarn();
      onDownload();
      window.open(installer.downloadUrl, '_blank');
    } else {
      cancel();
    }
    setShowDialog(false);
  };

  useEffect(() => {
    if (recentlyWarned() || (fetched && !detected)) {
      proceed();
      return;
    }
    if (detected) {
      setShowDialog(true);
    }
  }, [fetching, recordLastWarn, fetched, detected, setShowDialog, proceed]);

  useEffect(() => {
    if (!recentlyWarned() && !fetching && !fetched) {
      fetch(organizationId);
    }
  }, [organizationId, fetch, fetching, fetched]);

  if (!installer) {
    return '';
  }

  return (
    <ConfirmationDialog
      open={showDialog}
      handleClose={handleClose}
      title="Unstable Version Usage Detected"
      confirmText="Download"
      bodyText={
        <>
          We’ve identified that the current version of your software is causing some issues that may
          affect stability and performance. To ensure you get the best experience, we recommend that
          you download and update to the latest version. If you have any issues or questions, please
          contact us at (801) 763-5039.
        </>
      }
    />
  );
};

// ... rest of the imports

UnstableUsageDetector.propTypes = {
  fetch: PropTypes.func.isRequired,
  fetched: PropTypes.bool.isRequired,
  fetching: PropTypes.bool.isRequired,
  detected: PropTypes.bool.isRequired,
  recordLastWarn: PropTypes.func.isRequired,
  installer: PropTypes.shape({
    downloadUrl: PropTypes.string.isRequired
  }),
  proceed: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  organizationId: PropTypes.number.isRequired,
  onDownload: PropTypes.func.isRequired
};

UnstableUsageDetector.defaultProps = {
  installer: null
};

export default connect(
  (state, ownProps) => {
    const { organizationId } = ownProps;
    const currentOrganization = state.dibsOpener.unstableVersionUsageDetector.organizationId;

    return {
      fetching: state.dibsOpener.unstableVersionUsageDetector.fetching,
      fetched:
        !currentOrganization || organizationId !== currentOrganization
          ? false
          : state.dibsOpener.unstableVersionUsageDetector.fetched,
      detected: state.dibsOpener.unstableVersionUsageDetector.detected,
      installer: state.dibsOpener.unstableVersionUsageDetector.installer
    };
  },
  dispatch => {
    return {
      recordLastWarn: unstableVersionUsageWarned,
      fetch: organizationId => dispatch(checkUnstableVersionUsage(organizationId))
    };
  }
)(UnstableUsageDetector);
